import { useMemo } from "react";

interface UseProductResult {
  /** 产品ID */
  productId: string;
  /** 是否是 Winburst 品牌 */
  isWinburst: boolean;
}

/**
 * 根据当前域名判断产品ID
 *
 * 如果域名包含 REACT_APP_PRODUCT_DOMAIN，返回 REACT_APP_PRODUCT_ID，isWinburst = true
 * 否则返回 REACT_APP_777_PRODUCT_ID，isWinburst = false
 */
export function useProduct(): UseProductResult {
  return useMemo(() => {
    const winburstDomain = process.env.REACT_APP_PRODUCT_DOMAIN ?? "";
    const winburstProductId = process.env.REACT_APP_PRODUCT_ID ?? "";
    const otherProductId = process.env.REACT_APP_777_PRODUCT_ID ?? "";

    const currentHostname =
      typeof window !== "undefined" ? window.location.hostname : "";

    // 判断当前域名是否包含 Winburst 品牌域名
    const isWinburst = winburstDomain
      ? currentHostname.includes(winburstDomain)
      : false;

    const productId = isWinburst ? winburstProductId : otherProductId;

    return {
      productId,
      isWinburst,
    };
  }, []);
}